import AlertModalContainer from './alert-modal-container';

export default AlertModalContainer;
